"use client";
import { useQuery } from "@tanstack/react-query";
import ErrorComponent from "@/components/empty/ErrorComponent";
import { Card, CardHeader } from "@/components/headToHead/Card";
import Table from "@/components/headToHead/Table";
import LoadingBackdrop from "@/components/loadingBackdrop/LoadingBackdrop";
import { getTeamEfficiencyOverview } from "@/utils/api";
import { useHeadToHeadContext } from "@/utils/hooks/useHeadToHeadContext";
import useTable from "./useTable";
import styles from "./teamEfficiencyStats.module.scss";

const ContentContainer = () => {
  const { gameId } = useHeadToHeadContext();
  const { data, isLoading, isError } = useQuery({
    queryKey: ["teamEfficiencyStats", gameId],
    queryFn: () => getTeamEfficiencyOverview(gameId),
    select: (data) => data?.event,
  });
  const { columns, tableData } = useTable(data);

  if (isError && !data) {
    return <ErrorComponent />;
  } else if (isLoading && !data) {
    return <LoadingBackdrop loading={isLoading} />;
  }
  return <Table data={tableData} columns={columns} />;
};

const TeamEfficiencyStats = () => (
  <Card>
    <CardHeader title="Opponent Adjusted EPA" />
    <div className={styles.content}>
      <ContentContainer />
    </div>
  </Card>
);

export default TeamEfficiencyStats;
